import { useSelector } from 'react-redux';
import { useLocale } from '../contexts/LocaleContext';
import { centsToDollarsNumber, getLocalizedPricing } from '../lib/util/money';
import * as types from '../types';
import { FREE_TRIAL_SHIPPING_CODE } from '../types/Product';

/**
 * Returns the localized price for free trial shipping from the shipping options config.
 * This hook looks at ALL shipping options (not just available ones) to get the configured
 * price for free trial shipping.
 *
 * @returns The formatted price string (e.g., "$8.99" for USD or "CA$12.00" for CAD), or null if not found
 */
export default function useFreeTrialShippingPrice(): string | null {
  const { currency, currencyFormatter } = useLocale();
  const shippingOptions = useSelector((state: types.AppState) => state.config.shippingOptions);

  const freeTrialShippingOption = shippingOptions.find((option) => option.code === FREE_TRIAL_SHIPPING_CODE);

  if (!freeTrialShippingOption) {
    return null;
  }

  const priceInCents = getLocalizedPricing(freeTrialShippingOption.pricingInCents, currency);
  return currencyFormatter.format(centsToDollarsNumber(priceInCents));
}
